export const CHANGE_EMOTION_WORD_FIELD = 'CHANGE_EMOTION_WORD_FIELD' as const
export const SUBMIT_EMOTION_WORD = 'SUBMIT_EMOTION_WORD' as const
export const VALIDATE_EMOTION_WORD_FIELD = 'VALIDATE_EMOTION_WORD_FIELD' as const
export const ADD_EMOTION_WORD_FIELD_ERROR = 'ADD_EMOTION_WORD_FIELD_ERROR' as const
export const ADD_EMOTION_WORD_FIELDS_ERRORS = 'ADD_EMOTION_WORD_FIELDS_ERRORS' as const
export const CLEAR_EMOTION_WORD_FIELD_ERROR = 'CLEAR_EMOTION_WORD_FIELD_ERROR' as const
export const RESET_EMOTION_WORD_FORM_DATA = 'RESET_EMOTION_WORD_FORM_DATA' as const
export const PREDEFINE_EMOTION_WORD_FORM_DATA = 'PREDEFINE_EMOTION_WORD_FORM_DATA' as const
export const DELETE_EMOTION_WORD = 'DELETE_EMOTION_WORD' as const

export function changeEmotionWordFormField(key: string, value: string | number | boolean) {
  return { type: CHANGE_EMOTION_WORD_FIELD, payload: { key, value } }
}

export interface EmotionWordFormPayload {
  name: { value: string; validations?: string }
  definition: { value: string; validations?: string }
  moodMeter: { value: boolean; validations?: string }
  charter: { value: boolean; validations?: string }
  energyLower: { value: number; validations?: string }
  energyHigher: { value: number; validations?: string }
  pleasantnessLower: { value: number; validations?: string }
  pleasantnessHigher: { value: number; validations?: string }
  id?: { value: string; validations?: string }
}

export function submitEmotionWordFrom(payload: EmotionWordFormPayload) {
  return { type: SUBMIT_EMOTION_WORD, payload }
}

export function predefineEmotionWordForm(payload: Partial<EmotionWordFormData>) {
  return { type: PREDEFINE_EMOTION_WORD_FORM_DATA, payload }
}

export function addFieldError({ field, error }: { field: string; error: string }) {
  return { type: ADD_EMOTION_WORD_FIELD_ERROR, payload: { error, field } }
}

export function addFieldsErrors(errors: Record<string, string | undefined>) {
  return { type: ADD_EMOTION_WORD_FIELDS_ERRORS, payload: { errors } }
}

export function clearFieldError({ field }: { field: string }) {
  return { type: CLEAR_EMOTION_WORD_FIELD_ERROR, payload: { field } }
}

export function resetEmotionWordForm() {
  return { type: RESET_EMOTION_WORD_FORM_DATA }
}

export function validateField({
  field,
  value,
  validations,
}: {
  field: string
  value: string | number | boolean
  validations?: string
}) {
  return { type: VALIDATE_EMOTION_WORD_FIELD, payload: { field, value, validations } }
}

export function deleteEmotionWord({ emotionWordId }: { emotionWordId: string }) {
  return { type: DELETE_EMOTION_WORD, payload: { emotionWordId } }
}

export interface EmotionWordFormData {
  id: string | null
  name: string
  definition: string
  energyLower: number
  energyHigher: number
  pleasantnessLower: number
  pleasantnessHigher: number
  moodMeter: boolean
  charter: boolean
}
